import type { BuiltinFilters } from '../../../../../types/project';

export const qaIssueNameMap = {
    qa_not_proofread: 'Not reviewed',
    calc_is_fuzzy: 'Unverified',
    calc_qa_any_issue: 'Any QA issue',
    calc_qa_spelling_and_grammar: 'Spelling/grammar errors',
    calc_qa_mismatch_placeholder: 'Placeholder discrepancy',
    calc_qa_mismatch_html: 'HTML discrepancy',
    calc_qa_mismatch_url_count: 'Different number of URLs',
    calc_qa_mismatch_url: 'URL discrepancy',
    calc_qa_mismatch_leading_whitespace: 'Leading whitespace',
    calc_qa_mismatch_trailing_whitespace: 'Trailing whitespace',
    calc_qa_mismatch_email_count: 'Different number of e-mail addresses',
    calc_qa_mismatch_email: 'E-mail address discrepancy',
    calc_qa_mismatch_bracket: 'Bracket discrepancy',
    calc_qa_mismatch_number: 'Number discrepancy',
    calc_qa_double_space: 'Double space',
    calc_qa_special_placeholder: 'Invalid use of special placeholder',
    calc_qa_unbalanced_brackets: 'Unbalanced brackets',
};

export const qaIssueFilterMap: Record<keyof typeof qaIssueNameMap, BuiltinFilters> = {
    qa_not_proofread: 'builtin_6',
    calc_is_fuzzy: 'builtin_4',
    calc_qa_spelling_and_grammar: 'builtin_20',
    calc_qa_mismatch_placeholder: 'builtin_21',
    calc_qa_mismatch_html: 'builtin_22',
    calc_qa_mismatch_url_count: 'builtin_23',
    calc_qa_mismatch_url: 'builtin_24',
    calc_qa_mismatch_leading_whitespace: 'builtin_25',
    calc_qa_mismatch_trailing_whitespace: 'builtin_26',
    calc_qa_mismatch_email_count: 'builtin_27',
    calc_qa_mismatch_email: 'builtin_28',
    calc_qa_mismatch_bracket: 'builtin_29',
    calc_qa_mismatch_number: 'builtin_30',
    calc_qa_double_space: 'builtin_31',
    calc_qa_special_placeholder: 'builtin_32',
    calc_qa_unbalanced_brackets: 'builtin_33',
    calc_qa_any_issue: 'builtin_34',
};
